var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ItemBase',{staticClass:"ItemFirstVideo",attrs:{"label":_vm.$t('label'),"title":_vm.$t('title'),"icon":_vm.icon,"progress":_vm.$attrs.progress,"pulse":_vm.$attrs.pulse},on:{"click":function($event){return _vm.open()}}})}
var staticRenderFns = []

export { render, staticRenderFns }